/**
 * The sidebar icon set, shared by the tenant sidebar (layout/Sidebar.tsx) and
 * the Platform Admin sidebar (pages/platformAdmin/PlatformAdminNav.tsx), so the
 * two draw the same glyphs from one place (2026-10-03, TODO 525). Moved here
 * from Sidebar.tsx unchanged.
 *
 * Inline SVG, copied from the demo: stroke uses currentColor and the sizes come
 * from .ni-ico in theme.css, so an icon takes the row's colour and the active
 * row's blue without a colour of its own.
 */
export const Icon = {
  /*
   * 2026-08-20 (Shane) - three of the Assets & Maintenance rows drew the same
   * glyph. Icon.plant is a circle with eight radiating spokes, and so is
   * Icon.holiday, which is why both read as a snowflake; Plant, Tools and
   * Calibration then all shared Icon.plant. These three give them their own
   * shapes, in the same 16x16 stroke style as the rest of the set.
   */
  // Forklift - Plant & Maintenance.
  plantMachine: (
    <svg viewBox="0 0 16 16">
      <path d="M2 12V4h5v8" />
      <path d="M7 12h3" />
      <path d="M11 3v9" />
      <path d="M11 3h3" />
      <circle cx="4" cy="13.5" r="1.5" />
      <circle cx="9.5" cy="13.5" r="1.5" />
    </svg>
  ),
  // Spanner - Tools & Equipment.
  tools: (
    <svg viewBox="0 0 16 16">
      <path d="M10.5 1.5a3.5 3.5 0 00-3.1 5.1L1.8 12.2a1.2 1.2 0 001.7 1.7l5.6-5.6a3.5 3.5 0 004.4-4.4l-2 2-1.9-.5-.5-1.9 2-2a3.5 3.5 0 00-1.6-.4z" />
    </svg>
  ),
  // Calendar with a tick - Maintenance Schedule: what is due, across the lot.
  schedule: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="3" width="12" height="11" rx="1" />
      <path d="M2 6.5h12" />
      <path d="M5.5 1.5v3M10.5 1.5v3" />
      <path d="M5.5 10l1.8 1.8L10.5 8.5" />
    </svg>
  ),
  // Dial with a needle - Calibration Records: measured against a standard.
  calibration: (
    <svg viewBox="0 0 16 16">
      <path d="M2 11a6 6 0 1112 0" />
      <path d="M8 11L11 6.5" />
      <circle cx="8" cy="11" r="1" />
      <path d="M2 13.5h12" />
    </svg>
  ),
  dashboard: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="7" rx="1" />
      <rect x="9" y="9" width="5" height="3" rx="1" />
    </svg>
  ),
  hr: (
    <svg viewBox="0 0 16 16">
      <path d="M8 7a3 3 0 100-6 3 3 0 000 6z" />
      <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 16 16">
      <path d="M8 1L2 4v4c0 3.3 2.5 6.4 6 7.4 3.5-1 6-4.1 6-7.4V4L8 1z" />
      <path d="M5.5 8l2 2 3-3" />
    </svg>
  ),
  rota: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="2" width="12" height="12" rx="1" />
      <path d="M2 6h12" />
      <path d="M6 2v4" />
      <path d="M10 2v4" />
    </svg>
  ),
  training: (
    <svg viewBox="0 0 16 16">
      <path d="M3 2h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1z" />
      <path d="M5 6h6M5 9h4" />
    </svg>
  ),
  holiday: (
    <svg viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="3" />
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.2 3.2l1.4 1.4M11.4 11.4l1.4 1.4M3.2 12.8l1.4-1.4M11.4 4.6l1.4-1.4" />
    </svg>
  ),
  hs: (
    <svg viewBox="0 0 16 16">
      <path d="M8 1L2 4v4c0 3.3 2.5 6.4 6 7.4 3.5-1 6-4.1 6-7.4V4L8 1z" />
      <path d="M8 5v3" />
      <circle cx="8" cy="10" r=".6" fill="currentColor" />
    </svg>
  ),
  plant: (
    <svg viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="2.5" />
      <path d="M8 1v2.5M8 12.5V15M1 8h2.5M12.5 8H15M3.2 3.2l1.8 1.8M11 11l1.8 1.8M3.2 12.8l1.8-1.8M11 5l1.8-1.8" />
    </svg>
  ),
  fleet: (
    <svg viewBox="0 0 16 16">
      <path d="M1 9h10V5l-3-3H1v7z" />
      <path d="M11 6h2l2 3v3h-4V6z" />
      <circle cx="4" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
    </svg>
  ),
  accred: (
    <svg viewBox="0 0 16 16">
      <circle cx="8" cy="6" r="3" />
      <path d="M5.5 9L4 15l4-2 4 2-1.5-6" />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 16 16">
      <path d="M2 14V6l6-4 6 4v8" />
      <path d="M6 14v-4h4v4" />
      <path d="M2 14h12" />
    </svg>
  ),
  jobs: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="4" width="12" height="10" rx="1" />
      <path d="M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1" />
      <path d="M5 9h6M5 12h4" />
    </svg>
  ),
  care: (
    <svg viewBox="0 0 16 16">
      <path d="M8 7a3 3 0 100-6 3 3 0 000 6z" />
      <path d="M3 14c0-2.2 1.1-4 2.8-5M9 10.5l2 2 3-3" />
    </svg>
  ),
  hire: (
    <svg viewBox="0 0 16 16">
      <rect x="1" y="9" width="14" height="5" rx="1" />
      <path d="M3 9V6a5 5 0 0110 0v3" />
      <circle cx="5" cy="12" r="1" fill="currentColor" />
      <circle cx="11" cy="12" r="1" fill="currentColor" />
    </svg>
  ),
  lettings: (
    <svg viewBox="0 0 16 16">
      <path d="M2 3h12v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3z" />
      <path d="M2 3l6-2 6 2" />
      <path d="M6 8h4M6 11h2" />
      <path d="M10 6l1.5 1.5L14 5" />
    </svg>
  ),
  enquiries: (
    <svg viewBox="0 0 16 16">
      <path d="M2 3h12a1 1 0 011 1v7a1 1 0 01-1 1H9l-3 2v-2H2a1 1 0 01-1-1V4a1 1 0 011-1z" />
    </svg>
  ),
  quotes: (
    <svg viewBox="0 0 16 16">
      <path d="M3 2h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1z" />
      <path d="M5 6h6M5 9h3" />
      <path d="M10 10l1.5 1.5L14 9" />
    </svg>
  ),
  stock: (
    <svg viewBox="0 0 16 16">
      <path d="M2 4h12v8a1 1 0 01-1 1H3a1 1 0 01-1-1V4z" />
      <path d="M2 4l6-2 6 2" />
      <path d="M8 7v4M6 9h4" />
    </svg>
  ),
  erp: (
    <svg viewBox="0 0 16 16">
      <rect x="1" y="3" width="14" height="10" rx="1" />
      <path d="M1 6h14M5 6v7" />
    </svg>
  ),
  // Payroll glyph — wallet/pay-stub icon.
  payroll: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="3" width="12" height="10" rx="1" />
      <path d="M8 6v4M6 8h4M5 13h6" />
    </svg>
  ),
  suppliers: (
    <svg viewBox="0 0 16 16">
      <path d="M2 8c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6" />
      <path d="M6 10l2 2 4-4" strokeWidth="1.5" />
    </svg>
  ),
  // 2026-05-13 — Finance group add-on icons (Sub Contract /
  // Cashflow & Financial Modelling / Audit Pack). Simple shapes that
  // read clearly at sidebar size (14×14). All stroke-only to match the
  // existing visual language.
  subContract: (
    <svg viewBox="0 0 16 16">
      <path d="M3 2h7l3 3v9a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1z" />
      <path d="M10 2v3h3M5 9h6M5 11h4" />
    </svg>
  ),
  cashflow: (
    <svg viewBox="0 0 16 16">
      <path d="M2 13L6 9l3 3 5-6" />
      <path d="M10 6h4v4" />
    </svg>
  ),
  auditPack: (
    <svg viewBox="0 0 16 16">
      <rect x="3" y="2" width="10" height="12" rx="1" />
      <path d="M6 6h4M6 9h4M6 12h2" />
    </svg>
  ),
  directory: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="5" rx="1" />
      <rect x="9" y="9" width="5" height="5" rx="1" />
    </svg>
  ),
  glossary: (
    <svg viewBox="0 0 16 16">
      <path d="M3 2h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1z" />
      <path d="M5 5h6M5 8h6M5 11h4" />
    </svg>
  ),
  // Scales-of-justice glyph for Contracts & Legal.
  contracts: (
    <svg viewBox="0 0 16 16">
      <path d="M8 1v13" />
      <path d="M3 4h10" />
      <path d="M4 4l-2 5a3 3 0 006 0l-2-5" />
      <path d="M12 4l-2 5a3 3 0 006 0l-2-5" />
      <path d="M5 14h6" />
    </svg>
  ),
  // Stage 1.2e (2026-05-10) — tablet glyph for the Kiosks admin entry.
  // Rectangle with home-button dot at the bottom edge; matches the
  // stroke style of the other icons (line + minimal fills).
  kiosk: (
    <svg viewBox="0 0 16 16">
      <rect x="3" y="1.5" width="10" height="13" rx="1.2" />
      <circle cx="8" cy="12.5" r="0.6" />
    </svg>
  ),
  // Phase 1.4b (2026-05-20) — stacked-documents glyph for the Document
  // Register entry under Administration. Two offset rectangles to read
  // as "a collection of controlled documents".
  docRegister: (
    <svg viewBox="0 0 16 16">
      <rect x="2" y="3.5" width="9" height="11" rx="1" />
      <rect x="5" y="1.5" width="9" height="11" rx="1" />
      <path d="M7 5h5M7 8h5M7 11h3" />
    </svg>
  ),
  // Envelope - the Front Desk, where correspondence arrives before it is
  // anything else (2026-10-13). The set had no mail glyph; Icon.enquiries is
  // the CRM's and reusing it would have drawn the two as the same thing.
  mail: (
    <svg viewBox="0 0 16 16">
      <rect x="1.5" y="3" width="13" height="10" rx="1" />
      <path d="M1.5 4.5L8 9l6.5-4.5" />
    </svg>
  ),
  // Globe - the country Platform Admin is working in (2026-10-03, TODO 528).
  globe: (
    <svg viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="6" />
      <path d="M2 8h12" />
      <path d="M8 2c1.8 1.8 2.6 3.8 2.6 6S9.8 12.2 8 14c-1.8-1.8-2.6-3.8-2.6-6S6.2 3.8 8 2z" />
    </svg>
  ),
};
